import React, { cloneElement } from "react"
import PropTypes from "prop-types"
import Cookies from "universal-cookie"
//import "./topbar.less"
import Logo from "./365FarmNet.png"
import jwt from "jsonwebtoken"
import {parseSearch, serializeSearch} from "../../core/utils"

const publicDevKey=`-----BEGIN PUBLIC KEY-----
MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEA3fGJsV7dGX/elR1x8eLn
10ohRXTsqYRa169AK3htM3WednX1xQuVRSRdxOdKFohvAf62VS8fO4+t8tAKJuxV
b61UXpyGGCg50u1MDFs7ZkeW7Dv/AByR838ZLnalpcDSO1EyJgmZeRbfIpAG0O27
8RuP5+wn/CtLc6tROYehsYf8VxQ8/+UScgM4C1fMFA19kZ3nEnz9fJrp33YPYouQ
CpCC/+ScRfbneplAtrR4dC1WcviV1DsA7lEqEJrWstOvSxQhQYuXa7QbnR8ya3Hu
UFAl2QUSoqa+DpigYSwKVE0KDD12Y6+qwf4PF3Qa+WQzP1D1F84UOPqC7khSjLkN
kKwcR9JsDREc3y8q6C3e5CTYQemIv2zJ0NaaASU1B4n4xHlJDXpBUaptdBf+7pe+
8QBRU9Pgb0DdSShNKo6gpOlx9wJQoJkn/AMD4GDRWMph6qc6dHoMAMspm6BYfSLW
cyzWv1KrYZA8rIraPh3lLNAJ1UJKTIEASVfrKQCuBB7sJqb3a1H6trQdec3ZzYL/
RnQ/D7VZu+x7ArLDGeKZo3PmTGGoQaZT9XwVkZRt7ffTDsKmp2PiNI3jSRO5rsYc
ccWatbo95KbquQWqTmCr7oVJoH1uOHW3UsXkHwQM/2pP2MMOO9ndeFyfZ02PP7xV
cOBQA0uGG5KhdAVVZwJBhl0CAwEAAQ==
-----END PUBLIC KEY-----`

const publicProdKey = `-----BEGIN PUBLIC KEY-----
MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEA4fZ8T5DitZHxO+YFAk3j
VMkcEos48kGmaJymcDkgCZRgtxAgRbwh7CROvVswMnQAKeGdvxgAQcRow0+Pi7d9
PC6Je3R4u5zK2DLAq6U9LmpweuGBJljoTxu4I7B5oA+yLrYNZy4Ing3PdpqtC7uv
i/liifxYBvaAMk6+efaheXQ0x2PD85g1IHiKRapJbPl56F7ejaOrXdxXTujiLG0q
wjn44vB1KLEW9pNaRPEbNxK4h8oD+m6/ASc/K4DR6PHqeF2u2M6WmgcOw/UGtRSc
WlGO1B6TrjQ9ew5chT0NE8WXze74HO6IjfeQJ259KUf0ChHbQYaYdgwb5B/m21+r
e9P0cdt1u/dTftY37Tso7JN8kFYai3XroUw+LbJQD5J4pY0s1eAK+XyKDiYPpfBd
M+9Ib827crSOaqhaY3xmhg5pXb6JqUSZyzq4Y87EnkAiGU+J6Nrm4IaIz36jkXPn
ZttPOWa92sESlSTijk5JHcoxI4SSIvWaEV2Ak0pA5MpjDfCM6y6EzctMVFw6YfT9
7+w8/1mtF/6pxxCtR+WaTgEBgR3ZogoqyzuELEYbIrRVvUvwWjiGgrEmuZ8A+5ti
zHyOGUtshQWcXmRL5ts2BuNdea36nYjguJeatSAHe8v7KYqpBnoBF+HQI7S1lfAC
fsXzgfUdZbatqHUeyX/1qT0CAwEAAQ==
-----END PUBLIC KEY-----`

export default class Topbar extends React.Component {

  static propTypes = {
    layoutActions: PropTypes.object.isRequired
  }

  constructor(props, context) {
    super(props, context)
    
    this.cookies = new Cookies()
    
    this.fnTokenPresent = props.getConfigs().hasOwnProperty("jwt")
    this.fnTokenValid = false
    this.fnExternalToken = false
    
    this.state = { 
      url: props.specSelectors.url(), 
      selectedIndex: 0, 
      partnerId: this.cookies.get("partnerId"),
      partnerSecret: this.cookies.get("partnerSecret"),
      farmnettoken: this.fnTokenPresent? props.getConfigs().jwt:this.cookies.get("farmnettoken"),
      token: props.getConfigs().hasOwnProperty("token")?props.getConfigs().token:"",
    }
    
    if (!props.getConfigs().hasOwnProperty("token")) {
      this.updateToken(this.state.partnerId, this.state.partnerSecret, this.state.farmnettoken)
    } else {
      this.fnTokenValid = true
      this.fnExternalToken = true
    }
  }

  updateToken(partnerId, secret, farmnettoken) {
      if (!partnerId || !secret || !farmnettoken) {
        this.setState({ token: "" })
        return
      }
      
  
      let payload = {
          con: farmnettoken,
          iss: partnerId
      }
      let options = { 
          expiresIn: "1d",
          header: {
              ver: "0.1",
              type: "partner"
          }
      }
      
      const publicKey = (this.state && this.state.url.indexOf("production.yaml") > 0)?publicProdKey:publicDevKey
      
      jwt.verify(farmnettoken, publicKey, (error) => {
         if(!error) {
            this.fnTokenValid = true
         } else {
            this.fnTokenValid = false
         }
      })
      
      jwt.sign(payload, secret, options, (error, token) => {
        if(!error) {
           this.setState({ token })
        } else {
           throw Error(error)
        }
      })
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ url: nextProps.specSelectors.url() })
  }

  onUrlChange =(e)=> {
    let {target: {value}} = e
    this.setState({url: value})
  }

  onPartnerIdChange =(e)=> {
    let {target: {value}} = e
    this.setState({partnerId: value})
    this.cookies.set("partnerId", value)
    this.updateToken(value, this.state.partnerSecret, this.state.farmnettoken)
  }

  onPartnerSecretChange =(e)=> {
    let {target: {value}} = e
    this.setState({partnerSecret: value})
    this.cookies.set("partnerSecret", value)
    this.updateToken(this.state.partnerId, value, this.state.farmnettoken)
  }

  onFarmNetTokenChange =(e)=> {
    if (this.fnTokenPresent) {
      return
    }
    let {target: {value}} = e
    this.setState({farmnettoken: value})
    this.cookies.set("farmnettoken", value)
    this.updateToken(this.state.partnerId, this.state.partnerSecret, value)
  }

  loadSpec = (url) => {
    this.props.specActions.updateUrl(url)
    this.props.specActions.download(url)
  }

  onUrlSelect =(e)=> {
    let url = e.target.value || e.target.href
    this.loadSpec(url)
    this.setSelectedUrl(url)
    e.preventDefault()
  }

  downloadUrl = (e) => {
    this.loadSpec(this.state.url)
    e.preventDefault()
  }

  setSearch = (spec) => {
    let search = parseSearch()
    search["urls.primaryName"] = spec.name
    const newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}`
    if(window && window.history && window.history.pushState) {
      window.history.replaceState(null, "", `${newUrl}?${serializeSearch(search)}`)
    }
  }

  setSelectedUrl = (selectedUrl) => {
    const configs = this.props.getConfigs()
    const urls = configs.urls || []

    if(urls && urls.length) {
      if(selectedUrl)
      {
        urls.forEach((spec, i) => {
          if(spec.url === selectedUrl)
            {
              this.setState({selectedIndex: i})
              this.setSearch(spec)
            }
        })
      }
    }
  }

  componentDidMount() {
    const configs = this.props.getConfigs()
    const urls = configs.urls || []

    if(urls && urls.length) {
      var targetIndex = this.state.selectedIndex
      let primaryName = configs["urls.primaryName"]
      if(primaryName)
      {
        urls.forEach((spec, i) => {
          if(spec.name === primaryName)
            {
              this.setState({selectedIndex: i})
              targetIndex = i
            }
        })
      }

      this.loadSpec(urls[targetIndex].url)
    }
  }

  onFilterChange =(e) => {
    let {target: {value}} = e
    this.props.layoutActions.updateFilter(value)
  }

  render() {
    let { getComponent, specSelectors, getConfigs } = this.props
    const Button = getComponent("Button")
    const Link = getComponent("Link")

    let isLoading = specSelectors.loadingStatus() === "loading"
    let isFailed = specSelectors.loadingStatus() === "failed"

    let inputStyle = {}
    if(isFailed) inputStyle.color = "red"
    if(isLoading) inputStyle.color = "#aaa"

    const { urls } = getConfigs()
    let control = []
    let formOnSubmit = null

    if(urls) {
      let rows = []
      urls.forEach((link, i) => {
        rows.push(<option key={i} value={link.url}>{link.name}</option>)
      })

      control.push(
        <label className="select-label" htmlFor="select"><span>Select a definition</span>
          <select id="select" disabled={isLoading} onChange={ this.onUrlSelect } value={urls[this.state.selectedIndex].url}>
            {rows}
          </select>
        </label>
      )
    }
    else {
      formOnSubmit = this.downloadUrl
      control.push(<input className="download-url-input" placeholder="url" type={ this.fnTokenPresent?"hidden":"text" } onChange={ this.onUrlChange } value={this.state.url} disabled={isLoading} style={inputStyle} />)
      control.push(<input id="partner-id" className="partner-id-input" placeholder="Your Partner ID" type="text" onChange={ this.onPartnerIdChange } value={this.state.partnerId} disabled={isLoading} style={inputStyle} />)
      control.push(<input id="secret" className="secret-input" placeholder="Your Partner Secret" type="text" onChange={ this.onPartnerSecretChange } value={this.state.partnerSecret} disabled={isLoading} style={inputStyle} />)
      control.push(<input id="farmnettoken" className="farmnettoken-input" style={this.fnTokenValid?{}:{color:"red"}} placeholder="Connect Token" type={ this.fnTokenPresent?"hidden":"text" } onChange={ this.onFarmNetTokenChange } value={this.state.farmnettoken} disabled={isLoading} />)
      control.push(<input id="token" type="hidden" value={this.state.token} />)
      control.push(<Button className="download-url-button" style={this.fnTokenPresent?{display:"none"}:{}} onClick={ this.downloadUrl }>Explore</Button>)
    }

    return (
      <div className="topbar" style={this.fnExternalToken?{display:"none"}:{}}>
        <div className="wrapper">
          <div className="topbar-wrapper">
            <Link href="#">
              <img height="65" width="95" src={ Logo } alt="365FarmNet"/>
            </Link>
            <form className="download-url-wrapper" onSubmit={formOnSubmit}>
              {control.map((el, i) => cloneElement(el, { key: i }))}
            </form>
          </div>
        </div>
      </div>
    )
  }
}

Topbar.propTypes = {
  specSelectors: PropTypes.object.isRequired,
  specActions: PropTypes.object.isRequired,
  getComponent: PropTypes.func.isRequired,
  getConfigs: PropTypes.func.isRequired
}
